import { Component, Host, AttachInternals, Watch, Method, Prop, h, Event, Element, State } from '@stencil/core';

@Component({
  tag: 'jump-quantity',
  styleUrl: 'jump-quantity.scss',
  shadow: true,
  formAssociated: true,
})
export class JumpQuantity {

  @AttachInternals() internals: ElementInternals;
  @Element() el;

  @Prop() min: number = 1;
  @Prop() max: number;
  @Prop() step: number = 1;
  @Prop() label: string = '';
  @Prop() type: 'buttons' | 'dropdown' | 'input' = 'buttons';
  @Prop() variant: 'vertical' | 'horizontal' = 'vertical';
  @Prop() showButtons: boolean = true;
  @Prop() value: number = this.min;

  @State() internalValue: number;

  @Event({ eventName: 'jump-change' }) change;

  inputEl: HTMLInputElement;

  @Watch('value')
  onValueChange(newValue, oldValue) {
    this.change.emit({
      value: newValue,
      oldValue: oldValue,
    });
    this.internalValue = newValue ?? this.min;
    this.change.emit({ value: this.internalValue, oldValue });
    this.internals.setFormValue(this.internalValue.toString());
    this.internals.setFormValue(newValue);
  }

  /**
   * Get the current value
   */
  @Method()
  async getValue() {
    return this.value;
  }

  /**
   * Set the current value
   */
  @Method()
  async setMax(value: number) {
    this.max = value;
  }

  @Method()
  async reset() {
    this.value = this.min;
  }

  componentWillLoad() {
    this.internalValue = this.value ?? this.min;
    this.internals.setFormValue(this.internalValue.toString());
  }

  formResetCallback() {
    this.internals.setValidity({});
    this.internals.setFormValue('');
  }

  handleChange(event) {
    // Non permettere modifiche se il componente è disabilitato
    if (this.value === 0 || this.max === 0) {
      return;
    }
    
    let value = parseInt(event.target.value);
    if(value < this.min){
      this.value = this.min;
    } else if(value > this.max){
      this.value = this.max;
    } else {
      this.value = event.target.value;
    }
  }

  //avoid user can change the value below the min
  handleBlur(event) {
    if (event.target.value < this.min) {
      this.value = this.min;
    }
  }

  render() {
    // Disabilita il componente se value è 0 o max è 0
    const isDisabled = this.value === 0 || this.max === 0;
    
    return (
      <Host value={this.value} data-variant={this.variant} data-hasbuttons={this.showButtons} data-disabled={isDisabled}>
        {this.label && <label>{this.label}</label>}
        <div class={`jump-quantity__InnerWrapper`}>
        {this.showButtons &&
            <jump-button onClick={() => this.value = this.value - this.step} 
                         disabled={this.value <= this.min || isDisabled}
                         variant='neutral' size='custom'>
              <jump-icon library="lucide" name="minus" size="small"></jump-icon>
            </jump-button>}
          <input ref={(el) => {
            this.inputEl = el;
          }}
                 type='number'
                 value={this.internalValue}
                 onInput={(event) => this.handleChange(event)}
                 min={this.min}
                 max={this.max}
                 step={this.step}
                 disabled={isDisabled}
                 aria-hasbuttons={this.showButtons}
          />
          {this.showButtons &&
            <jump-button onClick={() => this.value = this.value + this.step} 
                         disabled={this.value >= this.max || isDisabled}
                         variant='neutral' size='custom'>
              <jump-icon library="lucide" name="plus" size="small"></jump-icon>
            </jump-button>}
        </div>
      </Host>
    );
  }
}
